import React, { useState, useRef, useEffect } from "react";
import { FaUserCircle } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import "../styles/TopNav.css";


const TopNav = ({ user, setIsLoggedIn, setUser, onProtectedAction }) => {
const [userOpen, setUserOpen] = useState(false);
const userRef = useRef(null);
const [adminOpen, setAdminOpen] = useState(false);
const adminRef = useRef(null);
const navigate = useNavigate();
const location = useLocation();
const isDashboard = location.pathname === "/dashboard";

const handleLogout = () => {
        localStorage.removeItem("auth");
        localStorage.removeItem("actualDates");
        localStorage.removeItem("actualVersusTheoreticalDates");
        localStorage.removeItem("grossMarginDates");
        localStorage.removeItem("theoreticalDates");
        setIsLoggedIn(false);
        setUser(null);
        navigate("/login");
};

useEffect(() => {
  const handleClickOutside = (e) => {
    // Close user menu
    if (
      userRef.current &&
      !userRef.current.contains(e.target)
    ) {
      setUserOpen(false);
    }

    // Close admin menu (only if it exists)
    if (
      adminRef.current &&
      !adminRef.current.contains(e.target)
    ) {
      setAdminOpen(false);
    }
  };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

return (
    <header className="top-nav">
        <div className="nav-left">
            <span className="app-title">MDB Reports</span>
        </div>

        <div className="nav-right">
            {!isDashboard && (
                <div
                    className="home-button"
                    onClick={() => {
                    setAdminOpen(false);
                    setUserOpen(false);
                    navigate("/dashboard");
                    }}
                    role="button"
                    tabIndex={0}
                >
                    Home
                </div>
            )}
            {user.user_type === "Admin" && (
                <div className="admin-menu"  ref={adminRef}>
                    <span
                        className="admin-label"
                        onClick={() => setAdminOpen(!adminOpen)}
                        data-testid="admin-label"
                    >
                        Admin
                    </span>
                
                    {adminOpen && (
                        <div className="admin-dropdown" data-testid="admin-dropdown">
                            <div
                                className="dropdown-item"
                                onClick={() => {
                                    setAdminOpen(false);
                                    onProtectedAction(() => navigate("/create-user"));
                                }}
                            >
                                Add User
                            </div>
                            <div
                                className="dropdown-item"
                                onClick={() => {
                                    setAdminOpen(false);
                                    onProtectedAction(() => navigate("/view-users"));
                                }}
                            >
                                View Users
                            </div>
                        </div>
                    )}
                </div>
                
            )}
            <div className="user-menu" ref={userRef}>
                <FaUserCircle
                    className="user-icon"
                    data-testid="user-icon"
                    onClick={() => setUserOpen(!userOpen)}
                />

                {userOpen && (
                    <div className="user-dropdown"  data-testid="user-dropdown">
                        <div className="user-name">{user.username}</div>
                        <div className="user-meta">{user.designation}</div>
                        <div className="user-role">{user.user_type}</div>
                        <div
                            className="user-logout"
                            onClick= {() => navigate('/reset-password')}
                        >
                            Reset Password
                        </div>
                        <div
                            className="user-logout"
                            onClick={handleLogout}
                            role="button"
                            tabIndex={0}
                            >
                            Logout
                        </div>
                    </div>
                )}
            </div>
        </div>
    </header>
    
)};

export default TopNav;
